// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cloud_logic': 'enable',
    'aws_cloud_logic_custom': [{"id":"ej911ywr29","name":"ReferencesCRUD","description":"","endpoint":"https://ej911ywr29.execute-api.us-east-1.amazonaws.com/Development","region":"us-east-1","paths":["/References","/References/123"]},{"id":"rlerk62h4b","name":"sampleCloudApi","description":"","endpoint":"https://rlerk62h4b.execute-api.us-east-1.amazonaws.com/Development","region":"us-east-1","paths":["/items","/items/123"]}],
    'aws_cognito_identity_pool_id': 'us-east-1:6f43f16c-96bf-4adc-a531-02271429e444',
    'aws_cognito_region': 'us-east-1',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'microdoser-hosting-mobilehub-618747754',
    'aws_content_delivery_bucket_region': 'us-east-1',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd1jlah4q1j2xq8.cloudfront.net',
    'aws_dynamodb': 'enable',
    'aws_dynamodb_all_tables_region': 'us-east-1',
    'aws_dynamodb_table_schemas': [{"tableName":"microdoser-mobilehub-618747754-References","attributes":[{"name":"ID","type":"S"},{"name":"Abstract","type":"S"},{"name":"Title","type":"S"},{"name":"URL","type":"S"}],"indexes":[],"region":"us-east-1","hashKey":"ID"}],
    'aws_mobile_analytics_app_id': '230cc601d3904d9098026b1873c553cd',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': '890d5821-18e9-472f-901e-157ab42ed1b0',
    'aws_project_name': 'microdoser',
    'aws_project_region': 'us-east-1',
    'aws_resource_bucket_name': 'microdoser-deployments-mobilehub-618747754',
    'aws_resource_name_prefix': 'microdoser-mobilehub-618747754',
    'aws_sign_in_enabled': 'enable',
    'aws_user_files': 'enable',
    'aws_user_files_s3_bucket': 'microdoser-userfiles-mobilehub-618747754',
    'aws_user_files_s3_bucket_region': 'us-east-1',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_DHhzrbCec',
    'aws_user_pools_mfa_type': 'ON',
    'aws_user_pools_web_client_id': '689c96pci7i0gvhmfdovdmnesk',
}

export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js